import { render, staticRenderFns } from "./CreateCorporate.vue?vue&type=template&id=2f176966"
import script from "./CreateCorporate.vue?vue&type=script&lang=js"
export * from "./CreateCorporate.vue?vue&type=script&lang=js"
import style0 from "./CreateCorporate.vue?vue&type=style&index=0&id=2f176966&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports